/**
 * Service: passesApi
 */
angular.module('acme.common.service.passesApi', [
  'acme.common.factory.apiVersion',
  'acme.common.factory.QueryStringBuilder'
])
.service('PassesApiService', ['$http', 'ApiVersionFactory', 'QueryStringBuilderFactory', function($http, ApiVersionFactory, QueryStringBuilderFactory) {

    return {

      service: '',

      init: function(endpoint) {
        this.service = endpoint + '/pass/templates';
      },

      list: function(props) {

        var q = '',
            av = new ApiVersionFactory();

        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: av.init({ url: this.service + q, version: 'v2' })
        });

      },

      detail: function(props) {

        var av = new ApiVersionFactory();

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/' + props.id, version: 'v2' })
        });

      },

      create: function(props) {

        var av = new ApiVersionFactory();

        return $http({
          method: 'post',
          url: av.init({ url: this.service, version: 'v2' }),
          data: {
            name: props.name,
            characters: props.characters,
            series: props.series,
            attributes: props.attributes,
            state: props.state
          }
        });

      },

      update: function(props) {

        var av = new ApiVersionFactory();

        return $http({
          method: 'put',
          url: av.init({ url: this.service + '/' + props.id, version: 'v2' }),
          data: {
            id: props.id,
            name: props.name,
            characters: props.characters,
            series: props.series,
            attributes: props.attributes,
            state: props.state
          }
        });

      },

      remove: function(props) {

        var av = new ApiVersionFactory();

        return $http({
          method: 'delete',
          url: av.init({ url: this.service + '/' + props.id, version: 'v2' })
        });

      }


    };

}]);